import { ConnectedPosition } from '@angular/cdk/overlay';

export type TooltipPosition = 'top' | 'bottom' | 'left' | 'right';

const OFFSET = 8;

const TOP: ConnectedPosition = {
  originX: 'center',
  originY: 'top',
  overlayX: 'center',
  overlayY: 'bottom',
  offsetY: -OFFSET,
};

const BOTTOM: ConnectedPosition = {
  originX: 'center',
  originY: 'bottom',
  overlayX: 'center',
  overlayY: 'top',
  offsetY: OFFSET,
};

const LEFT: ConnectedPosition = {
  originX: 'start',
  originY: 'center',
  overlayX: 'end',
  overlayY: 'center',
  offsetX: -OFFSET,
};

const RIGHT: ConnectedPosition = {
  originX: 'end',
  originY: 'center',
  overlayX: 'start',
  overlayY: 'center',
  offsetX: OFFSET,
};

const FALLBACKS: Record<TooltipPosition, ConnectedPosition[]> = {
  top: [TOP, BOTTOM, LEFT, RIGHT],
  bottom: [BOTTOM, TOP, LEFT, RIGHT],
  left: [LEFT, RIGHT, TOP, BOTTOM],
  right: [RIGHT, LEFT, TOP, BOTTOM],
};

/**
 * Returns preferred CDK connected positions for a DaisyUI-like tooltip direction,
 * with fallbacks so the overlay can flip near viewport edges.
 */
export function getTooltipPositions(
  position: TooltipPosition,
): ConnectedPosition[] {
  return FALLBACKS[position] ?? FALLBACKS.top;
}

/**
 * Maps an applied CDK connection pair back to a logical tooltip side.
 */
export function resolveTooltipPosition(
  pair: ConnectedPosition,
): TooltipPosition {
  if (pair.originY === 'top' && pair.overlayY === 'bottom') {
    return 'top';
  }
  if (pair.originY === 'bottom' && pair.overlayY === 'top') {
    return 'bottom';
  }
  if (pair.originX === 'start' && pair.overlayX === 'end') {
    return 'left';
  }
  if (pair.originX === 'end' && pair.overlayX === 'start') {
    return 'right';
  }
  return 'top';
}
